import React from "react";
import { useLocation } from "react-router-dom";
import i18n from "i18next";

import { Breadcrumb, Router } from "../types/router";

export function useLocale() {
  const [dateLocale, setDateLocale] = React.useState<string>("en");
  const [locale, setLocale] = React.useState<string>("");
  const [pathname, setPathname] = React.useState<string>("");

  const location = useLocation();

  React.useEffect(() => {
    const langCode = location.pathname.substring(1, 3);
    if (langCode === "en") {
      setDateLocale("en");
      setLocale("/en");
      setPathname(location.pathname.substring(3));
      i18n.changeLanguage("en");
    } else {
      setDateLocale("ja");
      setLocale("");
      setPathname("/en" + location.pathname);
      i18n.changeLanguage("ja");
    }
  }, [location]);

  return { dateLocale, locale, pathname };
}

export function navLocale(path: string) {
  const currentLang = i18n.language;
  if (currentLang === "en") {
    return "/en" + path;
  } else {
    return path;
  }
}

export function getBreadcrumbChain(
  routes: Router[],
  currentPath: string,
  prefix: string = ""
): Breadcrumb[] | null {
  for (const route of routes) {
    const fullPath = prefix + route.path;
    if (currentPath === fullPath) {
      return [{ route, fullPath }];
    }
    if (currentPath.startsWith(fullPath + "/") && route.children) {
      const childChain = getBreadcrumbChain(
        route.children,
        currentPath,
        fullPath + "/"
      );
      if (childChain) {
        return [{ route, fullPath }, ...childChain];
      }
    }
  }
  return null;
}
